import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';

export function AuthPendingStatus({ label }: { label: string }): ReactElement {
    return (
        <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center' }}>
            <Typography variant="h6" component="p">
                {label}
            </Typography>
            <CircularProgress size={24} />
        </Stack>
    );
}
